export enum AuthStatusEnum {
  LOADING = "LOADING",
  LOGGED_IN = "LOGGED_IN",
  LOGGED_OUT = "LOGGED_OUT",
}

export enum UserRoleEnum {
  SUPERADMIN = "superadmin",
  ADMIN = "admin",
  USER = "user",
  SECURITY = "security",
}

interface EmergencyContact {
  name: string;
  phone: string;
  relationship: string;
}

interface Profile {
  emergencyContact: EmergencyContact;
}

interface ActiveEmployment {
  title: string;
  unitName: string;
  unitId: string;
  managerId: string;
}

export interface IUser {
  id: string;
  realmId: string;
  createdAt: string; // ISO tarih string
  updatedAt: string;
  email: string;
  name: string;
  surname: string;
  phone: string;
  birthday: string; // Tarih string formatında geliyor
  photo: string | null;
  tckn: string;
  role: UserRoleEnum;
  status: "active" | "inactive";
  profile: Profile;
  activeEmployments: ActiveEmployment[];
  featureFlags: Record<string, boolean>;
}

export interface AuthTokenResponse {
  accessToken: string;
  refreshToken: string;
  accessTokenExpiresAt: string;
  refreshTokenExpiresAt: string;
}

export interface IUserLoginResponse {
  token: string;
  refreshToken?: string;
  user: IUser;
}

export interface IMeResponse {
  user: IUser;
}

export interface SmsInitResponse {
  nonce: string;
}

export interface SmsInitEndRequest {
  otp: string;
  nonce: string;
}

export interface LogoutResponseDto {
  success: boolean;
  message: string;
}
